import { connect } from "react-redux";

import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { ExternalBindingPath } from "../../../Engine/Core/CoreTypes";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { IHelperFunctionsCallContext } from "../../../Engine/Form/CustomizationContexts/HelperFunctionContext/IHelperFunctionsCallContext";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withExternalMountingEventReporting } from "../../Services/ExternalMountingEventReporting/withExternalMountingEventReporting";
import { AbsoluteResolvedModelPath, createAbsolute } from "../../../../../Common/ModelPath/ModelPath";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { withControlDebugInfo } from "../../withControlDebugInfo";

import { CustomSuggestComboBox, Item } from "./CustomSuggestComboBox";

interface CustomSuggestComboBoxContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    disabled2?: EvaluableProp<boolean>;
    viewModelSelect: ViewModelSelect;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
    query: (
        callContext: IHelperFunctionsCallContext,
        search: string,
        options: { bindingPath: ExternalBindingPath }
    ) => Promise<Item[]>;
}

const mapStateToProps = (state: FullFormState, ownProps: CustomSuggestComboBoxContainerProps) => {
    const { bindingPath, viewModelSelect, disabled2, processEvaluableProp } = ownProps;
    const controlModel = viewModelSelect.controlModel(state, bindingPath);

    return {
        value: { displayValue: controlModel.value ?? "", payload: {} },
        disabled: processEvaluableProp(state, disabled2) || controlModel.disabled,
        error: controlModel.error,
        warning: controlModel.warning,
        isReadOnly: Boolean(state.settings.isReadOnly),
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: CustomSuggestComboBoxContainerProps) => {
    const { bindingPath } = ownProps;

    return {
        onChange: (value: undefined | null | string) => dispatch(setToModel(bindingPath, "value", value)),
        setInfo: (path: ExternalBindingPath, value: string) =>
            dispatch(setToModel(createAbsolute(path), "value", value)),
        onQuery: (search: string): Promise<Item[]> =>
            dispatch(async (_, __, form) =>
                ownProps.query(form.getHelperFunctionsCallContext(), search, {
                    bindingPath: ownProps.bindingPath.toLegacyPath(),
                })
            ),
    };
};

export const CustomSuggestComboBoxContainer = withResolvePaths(
    withViewModelSelect(
        withEvaluators(
            connect(
                mapStateToProps,
                mapDispatchToProps
            )(withFocusManagement(withExternalMountingEventReporting(withControlDebugInfo(CustomSuggestComboBox))))
        )
    )
);
